import type { TFunction } from "i18next";

export const getTranslationOrValue = (t: TFunction, value?: string) => {
  if (!value) return "";
  const isTranslationKey = /^[a-z]+(_[a-z]+)*$/.test(value);
  return isTranslationKey ? t(`v8_${value}`, value) : value;
};
